window.Visualizations.Highcharts.SimpleBar = Object.assign({}, window.Visualizations.Highcharts.Base, {
  render: function (opts) {
    this.renderChart(opts.highchart_html_id, opts, {
      chart: {
        type: 'bar'
      },
      xAxis: {
        categories: opts.categories
      },
      yAxis: {
        min: 0,
        title: {
          text: opts.y_title
        }
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: 0,
        y: 80,
        floating: true,
        borderWidth: 1,
        backgroundColor:
          '#FFFFFF',
        shadow: true
      },
      series: opts.series,
      colors: [
        '#009FE3',
        '#2C3F3C',
        '#A3C537',
        '#F09E02',
        '#6C145C',
        '#A54417',
        '#FDEEDC',
        '#277532',
        '#A31916',
        '#E6F5FE'
      ]
    });
  }
});
